import React from 'react';
import { Row, Col, Space, Input, Select, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import DateRangeFilter from '../../components/DateRangeFilter';

const JobFilters = ({
  filters,
  setFilters,
  dateFilter,
  onDateFilterChange,
  vans,
  channels,
  onSearch,
  onCreateJob,
}) => (
  <>
    <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 24, flexWrap: 'wrap' }}>
      <Col xs={24} sm={12} md={10} lg={8} xl={8}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <span style={{ fontWeight: 500 }}>Date Range:</span>
          <DateRangeFilter value={dateFilter} onChange={onDateFilterChange} />
        </Space>
      </Col>
    </Row>

    <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 16, flexWrap: 'wrap', display: 'flex' }}>
      <Col flex="220px" style={{ marginRight: 16 }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <span style={{ fontWeight: 500 }}>Search</span>
          <Input.Search
            placeholder="Reference, postcode, van, customer…"
            value={filters.search}
            onChange={e => setFilters(f => ({ ...f, search: e.target.value }))}
            onSearch={onSearch}
            allowClear
            style={{ width: '100%' }}
          />
        </Space>
      </Col>
      <Col flex="180px">
        <Space direction="vertical" style={{ width: '100%' }}>
          <span style={{ fontWeight: 500 }}>Status</span>
          <Select
            mode="multiple"
            allowClear
            style={{ width: '100%' }}
            placeholder="Status"
            value={filters.status}
            onChange={val => setFilters(f => ({ ...f, status: val }))}
          >
            <Select.Option value="completed">Completed</Select.Option>
            <Select.Option value="assigned">Assigned</Select.Option>
            <Select.Option value="unassigned">Unassigned</Select.Option>
            <Select.Option value="cancelled">Cancelled</Select.Option>
          </Select>
        </Space>
      </Col>
      <Col flex="180px">
        <Space direction="vertical" style={{ width: '100%' }}>
          <span style={{ fontWeight: 500 }}>Payment Status</span>
          <Select
            allowClear
            style={{ width: '100%' }}
            placeholder="Payment Status"
            value={filters.paymentStatus || undefined}
            onChange={val => setFilters(f => ({ ...f, paymentStatus: val }))}
          >
            <Select.Option value="pending">Pending</Select.Option>
            <Select.Option value="paid">Paid</Select.Option>
            <Select.Option value="overdue">Overdue</Select.Option>
            <Select.Option value="cancelled">Cancelled</Select.Option>
          </Select>
        </Space>
      </Col>
      <Col flex="180px">
        <Space direction="vertical" style={{ width: '100%' }}>
          <span style={{ fontWeight: 500 }}>PL Position</span>
          <Select
            allowClear
            style={{ width: '100%' }}
            placeholder="PL Position"
            value={filters.plPosition || undefined}
            onChange={val => setFilters(f => ({ ...f, plPosition: val }))}
          >
            <Select.Option value="income">Income</Select.Option>
            <Select.Option value="expense">Expense</Select.Option>
          </Select>
        </Space>
      </Col>
      <Col flex="180px">
        <Space direction="vertical" style={{ width: '100%' }}>
          <span style={{ fontWeight: 500 }}>Channel</span>
          <Select
            allowClear
            style={{ width: '100%' }}
            placeholder="Channel"
            value={filters.channel || undefined}
            onChange={val => setFilters(f => ({ ...f, channel: val }))}
          >
            {channels.map(ch => (
              <Select.Option key={ch._id || ch.name} value={ch.name}>{ch.name}</Select.Option>
            ))}
          </Select>
        </Space>
      </Col>
      <Col flex="180px">
        <Space direction="vertical" style={{ width: '100%' }}>
          <span style={{ fontWeight: 500 }}>Van</span>
          <Select
            allowClear
            style={{ width: '100%' }}
            placeholder="Van"
            value={filters.van || undefined}
            onChange={val => setFilters(f => ({ ...f, van: val }))}
          >
            {vans.map(van => (
              <Select.Option key={van._id || van.registration} value={van._id || van.registration}>
                {van.registration}
              </Select.Option>
            ))}
          </Select>
        </Space>
      </Col>
    </Row>

    <div style={{ marginTop: 16, textAlign: 'right' }}>
      <Button type="primary" icon={<PlusOutlined />} onClick={onCreateJob}>
        Create Job
      </Button>
    </div>
  </>
);

export default JobFilters;
